module.exports = __webpack_public_path__ + "assets/img/fcdefe880d6a7b86240cdc1870dd3378.png";